import React, { Component, MouseEventHandler, ReactNode } from 'react';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { Checkbox, Collapse, List, ListItemButton, ListItemText, SxProps, Theme } from '@mui/material';

interface Props {
  readonly text: string;
  readonly disabled?: boolean;
  readonly expanded: boolean;
  readonly checked: boolean;
  readonly indeterminate?: boolean;
  readonly onClick: () => void;
  readonly onExpanded?: () => void;
  readonly sx?: SxProps<Theme>;
  readonly children?: ReactNode[];
}

export default class TreeItem extends Component<Props> {
  onExpansionItemClick: MouseEventHandler<SVGSVGElement> = (event) => {
    event.stopPropagation();

    if (this.props.disabled) {
      return;
    }

    this.props.onExpanded!();
  };

  render() {
    const hasChildren = this.props.children && this.props.children.length > 0;
    const ExpansionIcon = this.props.expanded === true ? ExpandLess : ExpandMore;

    const listItem = (
      <ListItemButton dense sx={this.props.sx} disabled={this.props.disabled} onClick={this.props.onClick}>
        <Checkbox
          color="default"
          indeterminate={this.props.indeterminate}
          indeterminateIcon={<IndeterminateCheckBoxIcon sx={{ color: 'primary.main' }} />}
          disableRipple
          tabIndex={-1}
          disabled={this.props.disabled}
          checked={this.props.checked}
        />
        <ListItemText primary={this.props.text} />

        {hasChildren ? <ExpansionIcon onClick={this.onExpansionItemClick} /> : null}
      </ListItemButton>
    );

    if (!hasChildren) {
      return listItem;
    }

    const children = (
      <Collapse in={this.props.expanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {this.props.children}
        </List>
      </Collapse>
    );

    return (
      <>
        {listItem}
        {children}
      </>
    );
  }
}
